import {
  Grid,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { Controller, FieldError } from "react-hook-form";

const DescGrid = styled(Grid)(({ theme }) => ({
  padding: "1%",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "10%",
}));

const FullTextField = styled(TextField)(({ theme }) => ({
  width: "80%",
}));

interface CustomTextFieldProps {
  name: string;
  control: any;  // This should be typed to match your form control, e.g., Control<FieldValues, any>
  label: string;
  inputMode?: "search" | "text" | "email" | "numeric" | "tel";
  helperText?: string;
  disabled?: boolean;
  error?: FieldError | undefined;
}
export const InputTextFieldForm: React.FC<CustomTextFieldProps> = ({
  name,
  control,
  label,
  inputMode,
  helperText,
  disabled = false,
  error,
}) => {
  return (
    <Grid container justifyContent="center">
      <DescGrid container justifyContent="center">
        <TitleGrid item xs={12}>
          <Typography variant="h6" color="black">
            {label}
          </Typography>
        </TitleGrid>
        <Grid container justifyContent="center" item xs={12}>
          <Controller
            name={name}
            control={control}
            render={({ field }) => (
              <FullTextField
                {...field}
                helperText={error ? error.message : helperText}
                error={!!error}
                disabled={disabled}
                fullWidth
                variant="outlined"
                inputMode={inputMode ?? "text"}
              />
            )}
          />
        </Grid>
      </DescGrid>
    </Grid>
  );
}